import { Layout } from 'src/components/layout/layout';
import Component from 'src/components/Frauds/Frauds';

const Frauds = () => {
    return (
        <Layout>
            <Component />
        </Layout>
    );
};

export default Frauds;
